import 'foundation/js/foundation/foundation.js';
import 'foundation/js/foundation/foundation.reveal.js';
/**
 * Open tagged links in overlay
 */

// Save the original state on pageload
var originalState = null;
var state = {};

 function initializeState() {
    var tempState = {};

    tempState.title = document.title;
    tempState.image = $('meta[property="og:image"]').attr('content');
    tempState.description = $('meta[property="og:description"]').attr('content');
    tempState.url = window.location.href;
    tempState.action = 'close';

    return tempState;
}

function $overlayify(attrString, callback) {
    originalState = originalState || initializeState();
    attrString = attrString || 'data-js-overlay';
    var $links = $(`[${attrString}]`);
    var modal = null;
    // Is set to true if history.popState is active. Prevents readding the same items to the history
    var isPoppingState = false;

    if (!$('#modal').length) $('<div id="modal"></div>').appendTo('body');

    $links.unbind('click.overlay').bind('click.overlay', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        openOverlay.call(this, url);
    });

    /**
     * Set a new URL through PJAX if available
     * @param {string} urlString - The new url string to set.
     */
    function setUrl (urlString) {
        if ($.support.pjax) {
            window.history.pushState(state, state.title, urlString);
        } else {
            window.location.href = urlString;
        }
    }

    function openOverlay (url) {
        modal = $('<div data-reveal>').addClass('reveal-modal').appendTo('body');
        $.get(url, function(data) {
            var theData = data;
            var $modal = modal.empty().html($(theData).find('#main')).append('<a class="close-reveal-modal">&#215;</a>');
            $modal.foundation('reveal', 'open', {
                animation: 'fade'
            });

            $(document).trigger('overlay:loaded');

            if(!isPoppingState) {
                setState({
                    url: window.location.origin + url,
                    action: 'open'
                });
                setUrl(url);
            }

            isPoppingState = false;
        });
    }

    function setState(stateObject) {

        state.title = stateObject.title || $('[data-js-poster-title]', modal).text();
        state.image = stateObject.image || window.location.origin + $('[data-js-poster-image]', modal).attr('src');
        state.description = stateObject.description || $('[data-js-poster-description]', modal).text();
        state.url = stateObject.url;
        state.action = stateObject.action;

        document.title = state.title;
        $('meta[property="og:image"]').attr('content', state.image.trim());
        $('meta[property="og:description"]').attr('content', state.description.trim());
        $('meta[name="description"]').attr('content', state.description.trim());
        $('meta[property="og:url"]').attr('content', state.url.trim());

    }

    function closeOverlay(e) {
        var $modal = e && $(e.target) || $('[data-reveal]');
        $modal.remove();

        if(!isPoppingState) {
            var closeState = $.extend(true, {}, originalState, {action: 'close'});

            setState(closeState);
            setUrl(closeState.url);
        }

        isPoppingState = false;
    }

    $(document).off('closed.fndtn.reveal').on('closed.fndtn.reveal', closeOverlay);

    $(window).off('popstate').on('popstate', function(e) {
        var poppedState = e.originalEvent.state || originalState;

        setState(poppedState);
        isPoppingState = true;

        if(poppedState.action === 'open') {
            openOverlay(poppedState.url);
        } else if(poppedState.action === 'close') {
            modal = $('[data-reveal]');
            modal.foundation('reveal', 'close');
        }
    });
}

export default $overlayify;



// WEBPACK FOOTER //
// ./src/js/app/components/overlay.js